"use client";

import { useCallback } from "react";
import type { ReactNode } from "react";
import { useConfirm as useLibConfirm } from "@dionatanbig2be/big2be-ui";

export interface ConfirmOptions {
    title: string;
    message?: ReactNode;
    confirmText?: string;
    cancelText?: string;
    /** "danger" → botão de confirmação vermelho (ações destrutivas). */
    tone?: "danger" | "primary";
}

/**
 * Adaptador fino sobre o `useConfirm` do big2be-ui (ConfirmProvider no
 * UIProviders), preservando o shape de opções que o app já usava.
 * Abre o diálogo e resolve com true/false conforme a escolha do usuário.
 */
export function useConfirm() {
    const confirm = useLibConfirm();

    return useCallback(
        (options: ConfirmOptions): Promise<boolean> =>
            confirm({
                title: options.title,
                description: options.message,
                confirmLabel: options.confirmText,
                cancelLabel: options.cancelText,
                tone: options.tone === "danger" ? "danger" : "neutral",
            }),
        [confirm]
    );
}
